module.exports = __webpack_public_path__ + "epdf-app/dashboard/batch-process-delay/process-delay-ewHXXXKa.html";